module.exports = __webpack_public_path__ + "static/img/productimg3.57380684.png";